
import React from 'react';
import { DataIndicators } from '../DataIndicators';
import { sortObjectArrayNaturally } from '../../lib';
import { isDataLoaded, Status } from '../../types';
import { useSiteListData } from '../../data/DataProviders/SiteListProvider';
import { Box, Button, List, Typography } from '@mui/material';
import { FlatListItem } from '../FlatListItem/FlatListItem';
import { pushAppRoute } from '../../data/domain/route-manager';
import { useHistory } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import { useDeviceCount } from '../../data/DataProviders/DeviceCountProvider';
import { isRecordFound, useSelectedOrganizationData } from '../../hooks/data-hooks';


export const SiteList: React.FC<{ orgId: string; locationId: string }> = (props) => {
    const history = useHistory();
    const siteListData = useSiteListData();
    const selectedOrganization = useSelectedOrganizationData();
    const deviceCount = useDeviceCount();
    const isEmpty = isDataLoaded(siteListData) && siteListData.value.length === 0;
    const orgId = isRecordFound(selectedOrganization) ? selectedOrganization.value.id : '';

    const NavigateToAddSite = (): void => {
        pushAppRoute(history, {
            type: 'AddSite', orgId: props.orgId, locationId: props.locationId
        });

    };

    return (
        <>
            {isEmpty &&
                <Box style={{ margin: 48,  marginLeft: 8 }}>
                    <Typography variant="h5" color="primary"> {`Sites (0)`}</Typography>
                    <Typography variant="subtitle2"> {`0 Total Devices`}</Typography>
                </Box>
            }
           
                <DataIndicators
                    errorMessage={'No Sites found'}
                    emptyMessage={'No Sites found'}
                    data={siteListData}
                    emptyIcon="LocationOn"
                    isEmpty={isEmpty}
                    withAction={true}
                    description={"Sites help you structure and organize your Devices. For example, a Site could represent a room or floor. Add a new Site to start connecting your Devices."}
                    action={<Button
                        startIcon={(<AddIcon fontSize="large" style={{ color: 'white' }} />)}
                        color="primary"
                        data-testid='add-site'
                        onClick={(): void => { NavigateToAddSite() }}
                        variant="contained">Add Site</Button>}
                />
         
            {isDataLoaded(siteListData) && siteListData.value.length > 0 && isDataLoaded(deviceCount) && (
                <>
                    <Box display="flex" justifyContent="space-between" style={{ marginTop: 48 }}>
                        <Typography variant="h5" color="primary"> {`Sites (${siteListData.value.length})`}
                        </Typography>
                        <Button
                            startIcon={(<AddIcon fontSize="large" style={{ color: 'white' }} />)}
                            color="primary"
                            data-testid='add-site'
                            onClick={(): void => { NavigateToAddSite() }}
                            variant="contained">Add Site</Button>
                    </Box>

                    {deviceCount.value ? <Typography variant="subtitle2"> {`${(deviceCount.value)} Total Devices`}</Typography>
                        :
                        <Typography variant="subtitle2"> {`0 Total Devices`}</Typography>}


                    <List>
                        {sortObjectArrayNaturally(siteListData.value, [{ sortField: 'siteName' }])
                            .map((site) => (
                                <FlatListItem key={site.siteId} item={{
                                    id: site.siteId, name: site.siteName, status: site.status as Status,
                                    isEditable: true
                                }} subTitleData={`${site.deviceCount} Total Devices`} hasStatus={true}
                                    navigate={{
                                        type: 'SiteProfile',
                                        orgId: orgId, locationId: props.locationId, siteId: site.siteId
                                    }}></FlatListItem>
                            ))}
                    </List>
                </>
            )}
        </>)
}